import { render, staticRenderFns } from "./status_badge.vue?vue&type=template&id=e7481f94"
import script from "./status_badge.vue?vue&type=script&lang=js"
export * from "./status_badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports